import { fromEvent as observableFromEvent } from "rxjs";

import type { IDirective, IWindowService, IScope } from "angular";
import { module } from "angular";
import { debounceTime } from "rxjs/operators";

export default class SetDatePositionDirective implements IDirective {
    public static $inject = ["$window"];

    public restrict = "A";

    public scope = {
        irSetDatePosition: "<",
    };

    constructor(private readonly $window: IWindowService) {}

    public link(scope: IScope & { irSetDatePosition: number }, element: JQuery) {
        scope.$watch("irSetDatePosition", () => {
            setPosition();
        });

        const resizeObservable = observableFromEvent(this.$window, "resize").pipe(debounceTime(300));
        const resizeSubscription = resizeObservable.subscribe(() => {
            setPosition();
        });

        scope.$on("$destroy", () => {
            resizeSubscription.unsubscribe();
        });

        // Trigger reflow at the bottom of UI queue.
        // Often this makes containers be initialized and parent().width() can be computed correctly
        // A reasize observer is probably the correct replacement for this and window.resize, but that's for a full rewrite
        this.$window.setTimeout(() => {
            setPosition();
        }, 0);

        function setPosition() {
            const timelineX = scope.irSetDatePosition;
            const relativeX = (timelineX / 1000) * element.parent().width();
            if (element.parent().width() === relativeX) {
                element.css("right", "0");
                element.css("transform", "translateX(0)");
            } else {
                element.css("left", `${relativeX}px`);
            }
        }
    }
}

module("mmGui").directive("irSetDatePosition", ["$window", ($window) => new SetDatePositionDirective($window)]);
